var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ]
    },
    [
      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
        _c(
          "div",
          { attrs: { align: "left" } },
          [
            _c("v-flex", { attrs: { md12: "" } }, [
              _c("h2", { staticClass: "h2_title" }, [
                _vm._v("Selección de transportista")
              ])
            ])
          ],
          1
        )
      ]),
      _c("v-divider"),
      _c("br"),
      _c("br"),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md9: "" } },
                [
                  _c(
                    "v-container",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showNuevoTransportista,
                          expression: "!showNuevoTransportista"
                        }
                      ]
                    },
                    [
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showNuevoTransportista,
                            expression: "!showNuevoTransportista"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "menu-props": { closeOnContentClick: true },
                          name: "transportistaSeleccionado",
                          disabled: _vm.showNuevoTransportista,
                          "error-messages": _vm.errors.collect(
                            "transportistaSeleccionado"
                          ),
                          "data-vv-name": "transportistaSeleccionado",
                          "search-input": _vm.search,
                          label: "Transportista",
                          items: _vm.transportistas,
                          "item-text": "desc",
                          "item-value": "cod"
                        },
                        on: {
                          "update:searchInput": function($event) {
                            _vm.search = $event
                          },
                          "update:search-input": function($event) {
                            _vm.search = $event
                          },
                          change: function($event) {
                            return _vm.changeFiltro()
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "no-data",
                            fn: function() {
                              return [
                                _c(
                                  "v-layout",
                                  [
                                    _c("div", { staticClass: "ma-3" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.search) +
                                          "\n                "
                                      )
                                    ]),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "#27488E",
                                          dark: "",
                                          type: "submit",
                                          disabled: _vm.invalid
                                        },
                                        on: { click: _vm.crearTransportista }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  crear\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.transportistaSeleccionado,
                          callback: function($$v) {
                            _vm.transportistaSeleccionado = $$v
                          },
                          expression: "transportistaSeleccionado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showNuevoTransportista,
                          expression: "showNuevoTransportista"
                        }
                      ],
                      attrs: { "grid-list-xs": "" }
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|rut|rutFormato|max:10",
                            expression: "'required|rut|rutFormato|max:10'"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.showNuevoTransportista,
                          counter: 10,
                          "error-messages": _vm.errors.collect(
                            "rutTransportista"
                          ),
                          "data-vv-name": "rutTransportista",
                          rows: "4",
                          label: "Rut del Transportista"
                        },
                        model: {
                          value: _vm.rutTransportista,
                          callback: function($$v) {
                            _vm.rutTransportista = $$v
                          },
                          expression: "rutTransportista"
                        }
                      }),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              rules: {
                                required: true
                              }
                            },
                            expression:
                              "{\n              rules: {\n                required: true,\n              },\n            }"
                          }
                        ],
                        attrs: {
                          "error-messages": _vm.errors.collect(
                            "nombreTransportista"
                          ),
                          "data-vv-name": "nombreTransportista",
                          disabled: !_vm.showNuevoTransportista,
                          rows: "4",
                          label: "Nombre del Transportista",
                          name: "comentario",
                          required: ""
                        },
                        model: {
                          value: _vm.nombreTransportista,
                          callback: function($$v) {
                            _vm.nombreTransportista = $$v
                          },
                          expression: "nombreTransportista"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-checkbox", {
                attrs: { label: "Asignar mandante" },
                model: {
                  value: _vm.addMandante,
                  callback: function($$v) {
                    _vm.addMandante = $$v
                  },
                  expression: "addMandante"
                }
              })
            ],
            1
          ),
          _c(
            "v-layout",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addMandante,
                  expression: "addMandante"
                }
              ]
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md9: "" } },
                [
                  _c("v-autocomplete", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      disabled: !_vm.addMandante,
                      label: "Mandante",
                      name: "mandante",
                      "data-vv-name": "mandante",
                      items: _vm.mandantes,
                      "item-text": "desc",
                      "item-value": "cod",
                      "error-messages": _vm.errors.collect("mandante")
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeFiltro()
                      }
                    },
                    model: {
                      value: _vm.modelMandante,
                      callback: function($$v) {
                        _vm.modelMandante = $$v
                      },
                      expression: "modelMandante"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs12: "", sm12: "", md3: "" } })
            ],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: {
                color: "#27488E",
                dark: "",
                type: "submit",
                disabled: _vm.invalid
              }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v(" check ")]),
              _vm._v("\n      Asignar\n    ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNuevoTransportista,
                  expression: "showNuevoTransportista"
                }
              ],
              attrs: { color: "#27488E", dark: "", outline: "" },
              on: { click: _vm.cancelarCreacion }
            },
            [_vm._v("\n      cancelar creación\n    ")]
          ),
          _c(
            "div",
            { staticStyle: { "max-height": "4px" } },
            [
              _c("v-progress-linear", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cargando,
                    expression: "cargando"
                  }
                ],
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.showConfirmacion,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje:
            "Se han seleccionado registros asociados actualmente a un transportista. ¿Desea reasignar estos registros al transportista seleccionado o desea mantener el transportista asignado? ",
          textoBtnSi: "Reasignar",
          textoBtnNo: "Mantener"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }